import { useState } from 'react';
import { getMessageWithPlaceholders } from 'shared-locales';
import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { ModalButtonWithForm, SortableList } from 'components/common';

import type { GetPathStepsMinimalRes } from 'shared-types/responses';

interface Props {
  steps: GetPathStepsMinimalRes['steps'];
  updateSteps: () => Promise<void>;
}

const PathStepsOrder = ({ steps = [], updateSteps }: Props) => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { path }
  } = useReduxState();

  const [order, setOrder] = useState(steps?.map((step) => step.id));

  const handleSubmit = async () => {
    const response = await api.put(`/admin/paths/${path.id}/steps-order`, {
      stepIds: order
    });
    if (!response.data && !response.data.success) return false;

    await updateSteps();
    dispatch(
      actions.addNotice({
        text: messages.commonEditOrderSuccess,
        type: 'success'
      })
    );

    return true;
  };

  return (
    <ModalButtonWithForm
      buttonCategory="light"
      buttonDisabled={!steps || !steps.length}
      buttonIcon="arrows-alt-v"
      buttonProps={{
        'aria-label': messages.commonEditOrder,
        'data-tooltip': messages.commonEditOrder
      }}
      buttonSize="header"
      contentStyle={{ padding: 0 }}
      modalActionCategory="success"
      modalActionText={messages.commonSave}
      modalTitle={messages.commonEditOrder}
      onSubmit={handleSubmit}
    >
      {() => (
        <SortableList
          items={
            steps?.length
              ? steps.map((step) => ({
                  key: step.id,
                  label:
                    step.items?.length > 1
                      ? getMessageWithPlaceholders({
                          message: messages.commonNumberOfAlternatives,
                          placeholders: {
                            numberOfAlternatives: step.items.length
                          }
                        })
                      : step.items?.[0]?.achievement?.title ||
                        step.items?.[0]?.course?.title ||
                        step.items?.[0]?.event?.title
                }))
              : []
          }
          itemWithBorder={true}
          listId="path-steps-order"
          onChange={(keys: number[]) => setOrder(keys)}
        />
      )}
    </ModalButtonWithForm>
  );
};

export default PathStepsOrder;
